import { FC, useCallback, useState } from 'react'
import { useQuery } from '@apollo/client/react'

import SearchableDropdownV2 from '~/src/components/generic/SearchableDropdownV2'

import {
  GetCostCentersForAutocompleteQuery,
  GetCostCentersForAutocompleteQueryVariables,
} from '~/src/components/shared/CostCenterAutocomplete/__generated_types__/queries.gql'
import { GET_COST_CENTERS } from '~/src/components/shared/CostCenterAutocomplete/queries'
import { CostCenter } from '~/src/components/shared/CostCenterAutocomplete/types'

const CostCenterAutocomplete: FC<{
  className?: string
  value?: string
  inputClassName?: string
  fuseThreshold?: number
  placeholder?: string
  onSelect: (costCenter: CostCenter) => void
  onClear?: () => void
}> = ({
  className,
  value = '',
  inputClassName,
  fuseThreshold,
  placeholder,
  onSelect,
  onClear,
}) => {
  const [searchValue, setSearchValue] = useState('')

  const { data } = useQuery<
    GetCostCentersForAutocompleteQuery,
    GetCostCentersForAutocompleteQueryVariables
  >(GET_COST_CENTERS)

  const costCenters = data?.getAllActiveCostCenters ?? []

  const handleSelect = useCallback(
    (costCenter: CostCenter) => {
      onSelect(costCenter)
      setSearchValue('')
    },
    [onSelect]
  )

  return (
    <SearchableDropdownV2
      className={className}
      fuseThreshold={fuseThreshold}
      inputClassName={inputClassName}
      maxNumOptions={100}
      options={costCenters}
      placeholder={placeholder || 'Add cost centers'}
      renderOption={({ name }) => (
        <div className="py-1.5">
          <div className="text-body-s">{name}</div>
        </div>
      )}
      searchKeys={['name']}
      value={searchValue || value}
      onChange={setSearchValue}
      onCloseHandler={onClear}
      onSelect={handleSelect}
    />
  )
}

export default CostCenterAutocomplete
